module.exports = __webpack_public_path__ + "static/media/email.775dfe7f.png";